import React, { useContext } from 'react';
import { LinkOff as LinkOffIcon } from '@mui/icons-material';

import { ControlWrap, TooltipWrap } from '../style';
import { SchemaDisplayContext } from '../context';
import { ROOT_NODE_TYPE } from '../../constants';
import { isResourceNodeType } from '../helpers/node';
import ConnectMp4 from '../../../resources/connect.mp4';
import ResourceConnectMp4 from '../../../resources/resource-connect.mp4';

function UnchainMarker(props) {
  const { id, topologyNodeType } = props;
  const { node: { onEdit, isConnected } } = useContext(SchemaDisplayContext);
  const isResource = isResourceNodeType(topologyNodeType);

  let render = false;

  if (isResource && !props.junctionNodeId) {
    render = true;
  }

  if (!isResource && topologyNodeType !== ROOT_NODE_TYPE && !isConnected(id)) {
    render = true;
  }

  const tooltipContent = (
    <div>
      <div className="description">
        This node is disconnected.
        {' '}
        <br />
        Please connect it with the right node in this Plaza.
      </div>
      <video
        width="216"
        height="122"
        loop
        autoPlay
      >
        <source
          src={ConnectMp4}
          type="video/mp4"
        />
      </video>
    </div>
  );

  const resourceTooltipContent = (
    <div>
      <div className="description">
        This node is disconnected.
        {' '}
        <br />
        Please connect it with the right node in this Plaza.
      </div>
      <video
        width="216"
        height="122"
        loop
        autoPlay
      >
        <source
          src={ResourceConnectMp4}
          type="video/mp4"
        />
      </video>
    </div>
  );

  return render ? (
    <TooltipWrap
      title={isResource ? resourceTooltipContent : tooltipContent}
      placement="top"
    >
      <ControlWrap
        className="unchained"
        onClick={() => onEdit(id)}
      >
        <LinkOffIcon />
      </ControlWrap>
    </TooltipWrap>
  ) : null;
}

export default UnchainMarker;
